/*=========================================================================================
  File Name: moduleNotificationsState.js
  Description: Notifications Module State
==========================================================================================*/

export default {
	fiveLatestNotifications: [],
	notifications: [],
	totalNotifications: 0,
	unreadNotifications: 0,
	limitPerPage: 20,
	currentPage: 1,
	limitLatest: 10
};
